<template>
  <v-container fluid>
    <v-layout row wrap mt-4>
      <v-flex xs12 md4 pr-4>
        <v-text-field label="Healthcare Provider Name" v-model="search.Name"></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field label="Practice Site Name" v-model="search.Site"></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-status label="Status" :multi="true" v-model="search.Status"></v-status>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <date-picker v-model="search.lower" label="Lower Bound"></date-picker>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <date-picker v-model="search.upper" label="Upper Bound"></date-picker>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" @click="search = {}">Clear</v-btn>
      <v-btn color="primary" @click="filterItems">Search</v-btn>
    </v-card-actions>
    <br />
    <v-card class="mt-4" elevation="1">
      <v-card-title>Applications Approved by Site Facilitator</v-card-title>
      <v-data-table :items="filteredApproved" :headers="headers">
        <template slot="items" slot-scope="props">
          <tr style="text-align:left;">
            <td>
              <v-btn icon color="primary" @click="open(props.item.Id)">
                <v-icon>open_in_new</v-icon>
              </v-btn>
              <v-btn icon color="primary" @click="review(props.item.Id)">
                <v-icon>assignment</v-icon>
              </v-btn>
              {{props.item.User.FirstName}} {{props.item.User.LastName}}
            </td>
            <td>{{primarySiteName(props.item.PracticeSiteInformation)}}</td>
            <td>{{props.item.CreatedOn | formattedDate}}</td>
            <td>{{props.item.CurrentStatus.Status.Description}}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-card class="mt-4" elevation="1">
      <v-card-title>All Applications</v-card-title>
      <v-data-table :items="filteredSubmitted" :headers="headers">
        <template slot="items" slot-scope="props">
          <tr style="text-align:left;">
            <td>
              <v-btn icon color="primary" @click="open(props.item.Id)">
                <v-icon>open_in_new</v-icon>
              </v-btn>
              <v-btn icon color="primary" @click="review(props.item.Id)">
                <v-icon>assignment</v-icon>
              </v-btn>
              {{props.item.User.FirstName}} {{props.item.User.LastName}}
            </td>
            <td>{{primarySiteName(props.item.PracticeSiteInformation)}}</td>
            <td>{{props.item.CreatedOn | formattedDate}}</td>
            <td>{{props.item.CurrentStatus.Status.Description}}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-card class="mt-4" elevation="1">
      <v-card-title>Applications in Default</v-card-title>
      <v-card-text>
        <v-data-table :items="filteredDefault" :headers="headers">
          <template slot="items" slot-scope="props">
            <tr style="text-align:left;">
              <td>
                <v-btn icon color="primary" @click="open(props.item.Id)">
                  <v-icon>open_in_new</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="review(props.item.Id)">
                  <v-icon>assignment</v-icon>
                </v-btn>
                {{props.item.User.FirstName}} {{props.item.User.LastName}}
              </td>
              <td>{{primarySiteName(props.item.PracticeSiteInformation)}}</td>
              <td>{{props.item.CreatedOn | formattedDate}}</td>
              <td>{{props.item.CurrentStatus.Status.Description}}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template> 
<script>
const moduleNameSpace = 'applications'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import LuStatusVue from '../LuStatus.vue'
import ReviewAppsVue from './ReviewApps.vue';
import DatePickerVue from '../DatePicker.vue'
export default {
  name: 'AdminInbox',
  data() {
    return {
      search: {
        Name: '',
        Site: '',
        Status: [],
        lower: moment(new Date()).add(-1, 'years').format("MM/DD/YYYY"),
        upper: moment(new Date()).format("MM/DD/YYYY")
      },
      headers: [
        { text: 'Healthcare Provider', value: 'User.FirstName' },
        { text: 'Practice Site', value: 'SiteInsitutionName' },
        { text: 'Application Created', value: 'CreatedOn' },
        { text: 'Status', value: 'Description' },
      ],
      menu: false,
      item: {},
      filteredSubmitted: [],
      filteredApproved: [],
      filteredDefault: [],
      filtered:[]
    }
  },
  created() {
    this.getInitialData()
  },
  methods: {
    ...mapActions(moduleNameSpace, ['getSubmitted', 'getApproved', 'getDefault']),
  async getInitialData() {
return new Promise((resolve, reject) => {
Promise.all([
this.getSubmitted(this.search).then((response) => {
this.filteredSubmitted = response.data
}),
this.getApproved(this.search).then((response) => {
this.filteredApproved = response.data
console.log(this.filteredApproved)
}),
this.getDefault(this.search).then((response) => {
this.filteredDefault = response.data
}),
]).then(() => {
resolve()
})
})
},
    primarySiteName(sites) {
      let name = ''
      sites.forEach((i) => {
        if (i.IsPrimarySite && i.SiteAddress) {
          name = i.SiteAddress.SiteInsitutionName
        }
      })
      return name
    },
    open(id) {
      this.$router.push({ path: `Application/${id}` })
    },
    review(val) {
      this.$emit('changeApp', val);
    },


    filterItems(){
      //debugger
      this.getInitialData().then(() => {
        if (
          this.search.Name ||
          this.search.Site ||
          this.search.Status.length > 0
        ) {
          this.filteredSubmitted = this.filter(this.submitted)
          this.filteredApproved = this.filter(this.approved)
          this.filteredDefault = this.filter(this.defaultApps)
        }
      })
    },
    filter(list){
      //debugger
      return list.filter((i) => {
          return (
            (this.search.Name &&
              i.User.FirstName.toLowerCase().includes(
                this.search.Name.toLowerCase()
              )) ||
            (this.search.Name &&
              i.User.LastName.toLowerCase().includes(
                this.search.Name.toLowerCase()
              )) ||
            (this.search.Site &&
              i.PracticeSiteInformation[0].SiteAddress.SiteInsitutionName.toLowerCase().includes(
                this.search.Site.toLowerCase()
              )) ||
            (this.search.Status &&
              i.CurrentStatus.StatusID &&
              this.search.Status.indexOf(i.CurrentStatus.StatusID) >= 0)
          )
        })
    }

  },
  computed: {
    ...mapGetters(moduleNameSpace, ['submitted', 'approved', 'defaultApps']),
  },
  components: {
    'v-status': LuStatusVue,
    'review' : ReviewAppsVue,
    'date-picker' : DatePickerVue
  },
}
</script>